import {FC, Fragment} from 'react'
import {useTranslation} from 'react-i18next'
import {FaExclamationCircle} from 'react-icons/fa'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {filterSelector, setIsFetchData} from 'src/redux/slices/filterSlices'
import styled from 'styled-components'
import {AppButton} from './AppButton/AppButton'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 3.5rem 0;
  background-color: #eaeaea;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #ee2b2b;
`

const Text = styled.p`
  font-size: 1rem;
  font-weight: 500;
`

interface TableFailedFetchDataProps {
  colSpan?: number
  onReloadTable: () => void
}

export const TableFailedFetchData: FC<TableFailedFetchDataProps> = ({colSpan, onReloadTable}) => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {isFetchData} = useAppSelector(filterSelector)

  const handleClick = () => {
    dispatch(setIsFetchData(true))
    onReloadTable()
  }

  return (
    <tr style={{backgroundColor: 'white'}}>
      <td colSpan={colSpan} style={{padding: 0}}>
        <Container>
          <Content>
            <FaExclamationCircle style={{fontSize: '3.5rem'}} />
            <Text>Error: {t('failed-to-load')}</Text>
          </Content>

          <div>
            <AppButton
              isLoading={isFetchData}
              text={
                <Fragment>
                  <i className='fas fa-sync-alt me-2' />
                  {t('reload table')}
                </Fragment>
              }
              onClick={handleClick}
            />
          </div>
        </Container>
      </td>
    </tr>
  )
}

TableFailedFetchData.defaultProps = {
  colSpan: 9,
}
